import { render, staticRenderFns } from "./inventory-list-head-office.vue?vue&type=template&id=6ce06c74&"
import script from "./inventory-list-head-office.vue?vue&type=script&lang=js&"
export * from "./inventory-list-head-office.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports